import {
	colors,
	ApCheckbox as UnstyledCheckbox,
} from '@alixpartners/ui-components';
import styled, { css } from 'styled-components';

export const ContentHeader = styled.div`
	font-size: 23px;
	font-weight: 500;
	line-height: 54px;
	letter-spacing: 0.3px;

	position: fixed;
	z-index: 2;
	background: white;
	width: 100%;
	left: 0;
	padding-left: 32px;
`;

export const ToggleWrapper = styled.div`
	font-size: 13px;
	font-style: normal;
	font-weight: 400;
	letter-spacing: 0.3px;
	text-align: left;
	margin-left: auto;

	display: flex;
	line-height: 53px;

	& > button:first-child {
		margin-top: 12px;
	}
	z-index: 3;
`;

export const Title = styled.div`
	margin-left: 4px;
	color: ${colors.grey5};
	min-width: 100px;
	line-height: 60px;
`;

export const LayoutRow = styled.div`
	display: flex;
	flex-direction: row;
	border-bottom: 1px solid ${colors.grey3};
	transition: all 0.05s ease-out;

	& + & {
		height: 51px;
		overflow: hidden;
		border-bottom: 1px dashed ${colors.grey3};

		button:first-child {
			margin-left: auto;
		}

		padding-top: 5px;
		height: 48px;

		> *:first-child {
			margin-left: auto;
		}
	}

	& > label {
		margin-right: 25px;
	}

	& > label:last-child {
		margin-right: 0;
	}
`;

export const Separator = styled.div`
	border-right: 1px solid ${colors.grey3};
	margin: 7px 14px 11px 15px;
`;

const expandedWrapperStyles = css`
	border-color: transparent;
	${LayoutRow} + ${LayoutRow} { 
		height: 0;
		padding-top: 0;
		border-color: transparent;
	}
`;

export const Wrapper = styled.div`
	position: relative;
	background-color: white;

	display: flex;
	flex-direction: column;
	z-index: 1;
	user-select: none;
	overflow: hidden;
	transition: all;

	${({ expanded }) => (expanded ? null : expandedWrapperStyles)};
	z-index: 2;
`;

export const CheckboxLabel = styled.span`
	font-size: 16px;
	padding-left: 10px;
`;

export const Checkbox = styled(UnstyledCheckbox)``;
